import type { EdgeDeviceRow } from "@lumora/bridge";
import { ConfirmGate } from "./ConfirmGate.js";

/** Per-device delete with ConfirmGate (#611). */
export function EdgeDevicesTable({
  devices,
  onDelete,
}: {
  devices: EdgeDeviceRow[];
  onDelete: (id: string) => void;
}) {
  if (devices.length === 0) {
    return <p className="muted">No edge devices yet.</p>;
  }
  return (
    <div className="ops-table-wrap">
      <table className="ops-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Firmware</th>
            <th>Last seen</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {devices.map((d) => (
            <tr key={d.id}>
              <td>{d.sandbox ? `${d.name} (sandbox)` : d.name}</td>
              <td>{d.firmwareVersion || "—"}</td>
              <td>{d.lastSeenAt ? new Date(d.lastSeenAt).toLocaleString() : "never"}</td>
              <td>
                <ConfirmGate
                  idleLabel="Delete"
                  confirmLabel="Yes, delete device"
                  onConfirm={() => onDelete(d.id)}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
